function sumOfArray(array) {
  return array.map(Number).reduce(function (pre, cur) {
    return pre + cur;
  })
}
export default{
    sumOfArray
}


// WEBPACK FOOTER //
// ./src/utils/sumOfArray.js